import React from 'react'
import { useForm } from 'react-hook-form'
import { useMutation, queryCache } from 'react-query'

import { useNotifications } from '../../containers/Notifications'
import { ID } from '../../types/id'

import { useWithAuth } from '../App'
import { Inquiries, addInquirySchema } from './utils'
import { InquiryForm } from './Form'

type Props = {
  onClose: () => void
  id: ID
  code: string
}

const endpoint = '/form/rest/inquiry/request'

export function AddInquiry({ onClose, code, id }: Props) {
  const form = useForm<Inquiries>({ validationSchema: addInquirySchema })
  const withAuth = useWithAuth()
  const { notify } = useNotifications()

  const [mutate] = useMutation<any, Inquiries>(
    (values) =>
      withAuth(endpoint, {
        method: 'POST',
        payload: values,
      })
        .then((res) => {
          if ('fieldErrors' in res) {
            // @todo notifications
          } else {
            queryCache.refetchQueries(`inquiry-${id}`)
            notify('Dodano zlecenie skali opisowej', 'success')
          }
        })
        .catch(console.log),

    {}
  )

  const handleSubmit = form.handleSubmit((values) => {
    const normalizedValues = {
      examinationCode: code,
      examinationId: id,
      ...(values.parent1.email && {
        parent1:
          values.parent1.type !== ''
            ? { type: values.parent1?.type, send: values.parent1?.send }
            : null,
        parent1Email: values.parent1.email,
      }),
      ...(values.parent2.email && {
        parent2:
          values.parent2.type !== ''
            ? { type: values.parent2?.type, send: values.parent2?.send }
            : null,
        parent2Email: values.parent2.email,
      }),
      ...(values.tutor1.email && {
        tutor1:
          values.tutor1.type !== ''
            ? { type: values.tutor1?.type, send: values.tutor1?.send }
            : null,
        tutor1Email: values.tutor1.email,
      }),
      ...(values.tutor2.email && {
        tutor2:
          values.tutor2.type !== ''
            ? { type: values.tutor2?.type, send: values.tutor2?.send }
            : null,
        tutor2Email: values.tutor2.email,
      }),
    }

    return mutate(normalizedValues)
  })

  return (
    <InquiryForm
      onSubmit={handleSubmit}
      onAbort={onClose}
      form={form}
      code={code}
    />
  )
}
